export default __webpack_public_path__ + "static/media/A_human_chest.43b6d052.png";